// Dependencies
import ExternalAPI from '../utils/api';

// Config
import { baseURL, endpoints, authNonce } from '../utils/config';

class WooptimaAPI extends ExternalAPI {
    getServicesData = async () => await this.request('getServicesData');
}

const FormAPI = new WooptimaAPI({
    baseURL: baseURL,
    namespace: 'wp-json/es/forms/v1',
    headers: {
        'Content-Type': 'application/json',
        'X-WP-Nonce': authNonce ?? ''
    },

    endpoints 
});

export default FormAPI;